module.exports = __webpack_public_path__ + "static/media/3.ac7ff32a.png";